import {defineStore} from "pinia";
export const useUserStore = defineStore('user', {
    // 1. State: The data we want to keep
    state: () => ({
        uid: localStorage.getItem('uid') || null,
        qrData: localStorage.getItem('qr_secret') || null,
        isLoggedIn: !!localStorage.getItem('uid'),
        isDining: localStorage.getItem('isDining') || false,
        isSleeping: localStorage.getItem('isSleeping') || false,
        isAdmin: localStorage.getItem('isAdmin') || false,
        isWitness: localStorage.getItem('isWitness') || false,
    }),

    // 2. Getters: Computed properties based on state
    getters: {
        isAuthenticated: (state) => !!state.uid,
    },

    // 3. Actions: Methods to change the state
    actions: {
        /**
         * Sets the user data after a successful login or QR scan
         * @param {string} uid
         * @param {string} qr
         * @param {boolean} isAdmin
         * @param {boolean} isSleeping
         * @param {boolean} isWitness
         * @param {boolean} isDining
         */
        setUser(uid, qr, isAdmin, isSleeping, isWitness, isDining) {
            this.uid = uid;
            this.qrData = qr;
            this.isLoggedIn = true;

            this.isAdmin = isAdmin;
            this.isSleeping = isSleeping;
            this.isWitness = isWitness;
            this.isDining = isDining;

            // console.log("setting user")
            // console.log(uid, qr, isAdmin, isSleeping, isWitness, isAdmin, isDining);

            // Persist to localStorage so data survives refresh
            localStorage.setItem('user_uid', uid);
            localStorage.setItem('user_qr', qr);

            localStorage.setItem('user_isAdmin', isAdmin);
            localStorage.setItem('user_isSleeping', isSleeping);
            localStorage.setItem('user_isWitness', isWitness);
            localStorage.setItem('user_isDining', isDining);
        },

        /**
         * Clears user data and redirects to home
         */
        logout() {
            this.uid = null;
            this.qrData = null;
            this.isLoggedIn = false;

            this.isAdmin = false;
            this.isSleeping = false;
            this.isWitness = false;
            this.isDining = false;

            localStorage.removeItem('user_uid');
            localStorage.removeItem('user_qr');

            localStorage.removeItem('user_isAdmin');
            localStorage.removeItem('user_isSleeping');
            localStorage.removeItem('user_isWitness');
            localStorage.removeItem('user_isDining');

            // If using vue-router inside the store:
            // this.router.push('/');
        },

        // /**
        //  * Initialize auth state (e.g., checking if session is still valid)
        //  */
        // initializeAuth() {
        //     const savedUid = localStorage.getItem('user_uid');
        //     if (savedUid) {
        //         this.uid = savedUid;
        //         this.qrData = localStorage.getItem('user_qr');
        //         this.isLoggedIn = true;
        //     }
        // }
    },
});
